/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Constants_PartnerUserRole } from '../models/Routemize_Constants_PartnerUserRole';
import type { Routemize_DTOs_Billing_PaymentMethodDto } from '../models/Routemize_DTOs_Billing_PaymentMethodDto';
import type { Routemize_DTOs_Partners_AddPartnerUserDto } from '../models/Routemize_DTOs_Partners_AddPartnerUserDto';
import type { Routemize_DTOs_Partners_AddPaymentMethodDto } from '../models/Routemize_DTOs_Partners_AddPaymentMethodDto';
import type { Routemize_DTOs_Partners_CancelTenantDto } from '../models/Routemize_DTOs_Partners_CancelTenantDto';
import type { Routemize_DTOs_Partners_ChangeTenantTierDto } from '../models/Routemize_DTOs_Partners_ChangeTenantTierDto';
import type { Routemize_DTOs_Partners_ManageTenantSeatsDto } from '../models/Routemize_DTOs_Partners_ManageTenantSeatsDto';
import type { Routemize_DTOs_Partners_PartnerAnalyticsDto } from '../models/Routemize_DTOs_Partners_PartnerAnalyticsDto';
import type { Routemize_DTOs_Partners_PartnerBillingSummaryDto } from '../models/Routemize_DTOs_Partners_PartnerBillingSummaryDto';
import type { Routemize_DTOs_Partners_PartnerDto } from '../models/Routemize_DTOs_Partners_PartnerDto';
import type { Routemize_DTOs_Partners_PartnerTenantDto } from '../models/Routemize_DTOs_Partners_PartnerTenantDto';
import type { Routemize_DTOs_Partners_PartnerUserDto } from '../models/Routemize_DTOs_Partners_PartnerUserDto';
import type { Routemize_DTOs_Partners_ProvisionTenantDto } from '../models/Routemize_DTOs_Partners_ProvisionTenantDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnerPortalService {
    /**
     * @returns Routemize_DTOs_Partners_PartnerDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetMyPartner(): CancelablePromise<Routemize_DTOs_Partners_PartnerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getMyPartner',
        });
    }
    /**
     * @returns Routemize_DTOs_Partners_PartnerTenantDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetMyTenants(): CancelablePromise<Array<Routemize_DTOs_Partners_PartnerTenantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getMyTenants',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Partners_PartnerTenantDto OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalProvisionTenant(
        requestBody?: Routemize_DTOs_Partners_ProvisionTenantDto,
    ): CancelablePromise<Routemize_DTOs_Partners_PartnerTenantDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/provisionTenant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalChangeTenantTier(
        requestBody?: Routemize_DTOs_Partners_ChangeTenantTierDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/changeTenantTier',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalAddSeat(
        requestBody?: Routemize_DTOs_Partners_ManageTenantSeatsDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/addSeat',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tenantId
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiAppPartnerPortalRemoveSeat(
        tenantId?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/partnerPortal/removeSeat',
            query: {
                'TenantId': tenantId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalCancelTenantSubscription(
        requestBody?: Routemize_DTOs_Partners_CancelTenantDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/cancelTenantSubscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_Partners_PartnerBillingSummaryDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetBillingSummary(): CancelablePromise<Routemize_DTOs_Partners_PartnerBillingSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getBillingSummary',
        });
    }
    /**
     * @returns Routemize_DTOs_Billing_PaymentMethodDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetPaymentMethods(): CancelablePromise<Array<Routemize_DTOs_Billing_PaymentMethodDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getPaymentMethods',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalAddPaymentMethod(
        requestBody?: Routemize_DTOs_Partners_AddPaymentMethodDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/addPaymentMethod',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param paymentMethodId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalSetPrimaryPaymentMethod(
        paymentMethodId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/setPrimaryPaymentMethod/{paymentMethodId}',
            path: {
                'paymentMethodId': paymentMethodId,
            },
        });
    }
    /**
     * @param paymentMethodId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppPartnerPortalDeletePaymentMethod(
        paymentMethodId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/partnerPortal/deletePaymentMethod/{paymentMethodId}',
            path: {
                'paymentMethodId': paymentMethodId,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_Partners_PartnerAnalyticsDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetPartnerAnalytics(): CancelablePromise<Routemize_DTOs_Partners_PartnerAnalyticsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getPartnerAnalytics',
        });
    }
    /**
     * @returns Routemize_DTOs_Partners_PartnerUserDto OK
     * @throws ApiError
     */
    public static getApiAppPartnerPortalGetMyPartnerUsers(): CancelablePromise<Array<Routemize_DTOs_Partners_PartnerUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/partnerPortal/getMyPartnerUsers',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Partners_PartnerUserDto OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalAddPartnerUser(
        requestBody?: Routemize_DTOs_Partners_AddPartnerUserDto,
    ): CancelablePromise<Routemize_DTOs_Partners_PartnerUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/addPartnerUser',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param partnerUserId
     * @param role  Possible values: Owner = 1, Member = 2
     * @returns Routemize_DTOs_Partners_PartnerUserDto OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalSetPartnerUserRole(
        partnerUserId: string,
        role?: Routemize_Constants_PartnerUserRole,
    ): CancelablePromise<Routemize_DTOs_Partners_PartnerUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/setPartnerUserRole/{partnerUserId}',
            path: {
                'partnerUserId': partnerUserId,
            },
            query: {
                'role': role,
            },
        });
    }
    /**
     * @param partnerUserId
     * @param isActive
     * @returns Routemize_DTOs_Partners_PartnerUserDto OK
     * @throws ApiError
     */
    public static postApiAppPartnerPortalSetPartnerUserActive(
        partnerUserId: string,
        isActive?: boolean,
    ): CancelablePromise<Routemize_DTOs_Partners_PartnerUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/partnerPortal/setPartnerUserActive/{partnerUserId}',
            path: {
                'partnerUserId': partnerUserId,
            },
            query: {
                'isActive': isActive,
            },
        });
    }
}
